import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import mairieMissionFormFields, { mairieMissionSaveUrl } from '@form/mairieMissionFormFields'

import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { updateNotification } from '@store/slice/mainSlice'
import { updateMissionFormObject, updateMissions, updateErrors, initMissionFormObject } from '@store/slice/missionSlice'
import { useEffect } from 'react'
import { post } from '@util/xhrAPI'
import { ROLE_SUPER_ADMIN } from '@router/Routes'
import useDynamicForm from '@hook/useDynamicForm'
import useStoreUpdate from '@hook/useStoreUpdate'
import useFormData from '@hook/useFormData'
import useMainData from '@hook/useMainData'
import Form from '@ui/elements/Form'
import useToggle from '@hook/useToggle'

const CreateMission = () => {
  const { mairieMissionFormObject, errors, missions } = useSelector(state => state.mission)
  const { data } = useSelector(state => state.main)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const loadData = useMainData()
  const [isLoading, toggleLoading] = useToggle(false)
  const [t] = useTranslation('mission')
  const toggleDynamicForm = useDynamicForm()
  const renderFormData = useFormData()
  const [updateFormObject, updateFormObjectProp] = useStoreUpdate(dispatch, updateMissionFormObject, mairieMissionFormObject)


  const saveForm = e => {
    toggleLoading()
    e.preventDefault()
    const missionCoordinates = mairieMissionFormObject.coordinates
    let formObject = {
      ...mairieMissionFormObject,
      coordinates: missionCoordinates && 'object' !== typeof missionCoordinates ? JSON.parse(missionCoordinates) : missionCoordinates
    }
    post(mairieMissionSaveUrl, renderFormData(formObject, ['coordinates']), response => {
      const { code, errors, mission } = response
      if (code === 200) {
        dispatch(updateMissions({ ...missions, [mission.id]: { ...mission } }))
        dispatch(updateNotification({ type: 'is-success', message: t('notifications.mission_saved') }))
        backToList()
      }
      if (Object.keys(errors).length) {
        dispatch(updateErrors(errors))
      }
      toggleLoading()
    })
  }

  const generateFormStep = step => {
    return mairieMissionFormFields(step, mairieMissionFormObject, errors, updateFormObject, updateFormObjectProp, saveForm, isLoading, t, toggleDynamicForm, data)
  }

  const fetchInitialData = () => {
    const dataObject = {
      cities: 'cities',
      mairies: 'mairies',
      missionSubjects: 'missionSubjects',
      billingTypes: 'billingTypes',
      pilots: 'users[roles]=role_pilot'
    }
    loadData(dataObject)
  }

  const backToList = () => {
    dispatch(initMissionFormObject())
    navigate(ROLE_SUPER_ADMIN['missions'])
  }

  useEffect(() => {
    fetchInitialData()
    updateMissions({ ...missions })
  }, [])

  return (
    <Div cssClass='create-mission-zone form columns is-multiline'>
      <Buttons buttons={
        {
          cssClass: 'back-to-list is-info is-small',
          callback: backToList,
          text: t('actions.back_to_missions_list'),
          icon: 'icon-keyboard_arrow_left'
        }
      } />
      <Div cssClass='form-header'>
        <h2>{t('form.mission_creation')}</h2>
      </Div>
      <Form>
        <Div cssClass='column is-12 mission-form-bloc'>
          <h4 className='block-title'></h4>
          {generateFormStep('mairie')}
        </Div>
        <Div cssClass='column is-12 mission-form-bloc'>
          <Div cssClass='columns is-multiline'>
            <Div cssClass='column is-6'>
              <h4 className='block-title'>{t('form.mission_responsible_infos')}</h4>
              <Div cssClass='columns is-multiline'>
                {generateFormStep('responsible')}
              </Div>
            </Div>
          </Div>
        </Div>

        <Div cssClass='column is-12 mission-form-bloc'>
          <Div cssClass='columns is-multiline'>
            <Div cssClass='column is-6'>
              <h4 className='block-title'>{t('form.mission_option')}</h4>
              <Div cssClass='columns is-multiline'>
                {generateFormStep('missionOptions')}
              </Div>
            </Div>
            <Div cssClass='column is-6'>
              <h4 className='block-title'>{t('form.personnalize_mission')}</h4>
              <Div cssClass='columns is-multiline'>
                {generateFormStep('mission')}
              </Div>
            </Div>
          </Div>
        </Div>
        <Div cssClass='column is-12 mission-form-bloc'>
          {generateFormStep('submit')}
        </Div>
      </Form>
    </Div>
  )
}

export default CreateMission